import { Http } from '../http';

export class Namespace {
  // eslint-disable-next-line no-useless-constructor,no-empty-function
  constructor(
    protected http: Http,
    protected httpV2: Http,
  ) {}
}
